/* eslint-disable prefer-destructuring */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTypedSelector } from "../../redux/hooks";
import newMessageFavicon from '../../img/favicons/favicon-blue-dot.ico';
import { selectAllChatUnreadMessages, selectIsNebulaChat } from "../../redux/slices";
import { usePolyglot } from "../../context/Polyglot";
import { useAppContext } from '../../context/AppContext/AppContext';
import { isPreview } from '../../helpers';
import { selectUnreadConversationSum } from '../../redux/slices/chatNSlice';

export const TabNotifications: React.FC = () => {
    const isNebulaChat = useTypedSelector(selectIsNebulaChat);

    const unreadOldChatCount = useTypedSelector(selectAllChatUnreadMessages)
    const unreadConversationSum = useTypedSelector(selectUnreadConversationSum);

    const unreadCount = isNebulaChat ? unreadConversationSum : unreadOldChatCount;

    const { appFavicon, appName, isPulseHd, isCallSwitch } = useAppContext();
    const { t } = usePolyglot();

    let unreadIcon = appFavicon;

    switch (true) {
        case isCallSwitch:
        case isPulseHd:
            break;
        default:
            unreadIcon = newMessageFavicon;
    }

    useEffect(() => {
        const electron = (window as any).electron;

        if (electron) {
            if (unreadCount > 0) {
                electron.send('set-badge-count', unreadCount);
            } else {
                electron.send('set-badge-count', 0);
            }
        }
    }, [unreadCount, isNebulaChat]);

    if (unreadCount > 0) {
        return (
            <Helmet defer={false}>
                <title>{`${appName}${isPreview ? ' - Preview' : ''} - ${t("phrases.%count_unread", unreadCount)}`}</title>
                <link rel='icon' href={unreadIcon} />
            </Helmet>
        );
    }

    return (
        <Helmet defer={false}>
            <title>{appName}{isPreview ? ' - Preview' : ''}</title>
            <link rel='icon' href={appFavicon} />
        </Helmet>
    );
};
